<template>
  <header 
    :class="[
      'tw-border-b tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-3 tw-fixed md:tw-sticky tw-top-0 tw-left-0 tw-right-0 tw-z-[1100] tw-w-full',
      theme === 'dark' ? 'tw-bg-[#0f1114] tw-border-[#1e2024]' : 'tw-bg-[#e9eef6] tw-border-gray-200 tw-shadow-sm'
    ]"
  >
    <nav class="tw-flex tw-items-center tw-justify-between tw-w-full">
      
      <!-- Left section: Menu + Title -->
      <div class="tw-flex tw-items-center tw-gap-2">
        <button v-if="!isActive('UnidadesPage') && !isActive('ConsultaAvancadaPage') && !isActive('ParametrosCheckoutPage')"
          @click="toggleSidebar" 
          :class="[
            'tw-p-2 tw-rounded-md', 
            theme === 'dark' ? 'hover:tw-bg-gray-800' : 'hover:tw-bg-gray-100'
          ]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" 
            :stroke="theme === 'dark' ? 'white' : '#374151'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><line x1="9" x2="9" y1="3" y2="21"/>
          </svg>
        </button>

        <div v-if="!isActive('UnidadesPage') && !isActive('ConsultaAvancadaPage') && !isActive('ParametrosCheckoutPage')" :class="['tw-h-8 tw-w-[1px]', theme === 'dark' ? 'tw-bg-gray-700' : 'tw-bg-gray-200']" class="tw-hidden xs:tw-block tw-mx-2"></div>

        <div class="tw-flex tw-flex-col tw-justify-center">
          <h1 :class="['tw-font-bold tw-leading-none tw-tracking-tight', theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-800', 'tw-text-xs xs:tw-text-sm md:tw-text-base tw-mt-1']">
            {{ vue_app_name }} <span class="tw-text-gray-500 tw-font-medium tw-ml-1 tw-text-[10px] xs:tw-text-xs">v{{ version }}</span>
          </h1>
        </div>
      </div>

      <!-- Right section: Actions -->
      <div class="tw-flex tw-items-center tw-gap-1 md:tw-gap-4">
        <!-- Theme toggle -->
        <button 
          @click="toggleTheme" 
          class="tw-p-1.5 md:tw-p-2 tw-rounded-full hover:tw-bg-white/10 tw-relative tw-w-8 md:tw-w-10 tw-h-8 md:tw-h-10 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
          style="will-change: transform; transform: translateZ(0);"
        >
          <transition name="theme-fade">
            <svg 
              v-if="theme === 'dark'"
              key="sun"
              xmlns="http://www.w3.org/2000/svg" 
              class="tw-w-4 md:tw-w-6 tw-h-4 md:tw-h-6 tw-absolute tw-stroke-white" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m0 13.5V21m8.966-8.966h-2.25M5.25 12H3m14.593-7.343l-1.591 1.591M6.75 17.25l-1.591 1.591M17.25 17.25l1.591 1.591M6.75 6.75L5.159 5.159M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>

            <svg 
              v-else
              key="moon"
              xmlns="http://www.w3.org/2000/svg" 
              class="tw-w-4 md:tw-w-6 tw-h-4 md:tw-h-6 tw-absolute tw-stroke-black" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
            </svg>
          </transition>
        </button>      
        <div class="tw-relative">
          <button 
            @click="menuUnidade = !menuUnidade; menuUser = false"
            :class="[
              'tw-flex tw-items-center tw-text-[10px] xs:tw-text-[11px] tw-tracking-wider focus:tw-outline-none', 
              theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-700 hover:tw-text-[#33b35a]'
            ]"
          >
            <span class="tw-font-bold">Unidades</span>
            <i class="fa-solid fa-chevron-down tw-ml-1 tw-text-[8px] xs:tw-text-[10px]" :class="{'tw-rotate-180': menuUnidade}"></i>
          </button>
          
          <div v-if="menuUnidade" 
            :class="[
              'tw-absolute tw-right-0 tw-mt-2 tw-w-48 xs:tw-w-56 tw-rounded-lg tw-shadow-xl tw-z-50 tw-overflow-hidden tw-border', 
              theme === 'dark' ? 'tw-bg-[#0f1114] tw-border-gray-800' : 'tw-bg-white tw-border-gray-200'
            ]"
          >
            <router-link to="/v2/unidades/" @click="menuUnidade = false" 
              :class="[
                'tw-flex tw-items-center tw-px-3 md:tw-px-4 tw-py-2 md:tw-py-3 tw-text-xs hover:tw-bg-[#33b35a] hover:tw-text-white tw-border-b', 
                theme === 'dark' ? 'tw-text-gray-300 tw-border-gray-800' : 'tw-text-gray-600 tw-border-gray-100'
              ]"
            >
              <i class="fa-solid fa-house tw-mr-2"></i> Minhas Unidades
            </router-link>
            <div class="tw-px-3 tw-py-2 tw-border-b"
                :class="theme === 'dark' ? 'tw-border-gray-800' : 'tw-border-gray-100'">

              <div class="tw-relative">
                <i
                  class="fa-solid fa-magnifying-glass tw-absolute tw-left-2 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400 tw-text-xs">
                </i>

                <input
                  v-model="buscaUnidade"
                  type="text"
                  placeholder="Buscar..."
                  :class="[
                    'tw-w-full tw-pl-7 tw-pr-2 tw-py-1.5 tw-text-xs tw-rounded-md focus:tw-outline-none',
                    theme === 'dark'
                      ? 'tw-bg-gray-900 tw-border tw-border-gray-700 tw-text-gray-300'
                      : 'tw-bg-gray-50 tw-border tw-border-gray-200 tw-text-gray-700'
                  ]"
                />
              </div>
            </div>

            <div class="tw-max-h-[30vh] tw-overflow-y-auto custom-scrollbar">
              <router-link
                v-for="unidade in unidadesFiltradas"
                :key="unidade.id"
                :to="'/v2/unidades/' + unidade.id"
                @click="menuUnidade = false"
                :class="[
                  'tw-block tw-px-3 md:tw-px-4 tw-py-2 md:tw-py-3 tw-text-xs hover:tw-bg-[#33b35a] hover:tw-text-white tw-cursor-pointer',
                  theme === 'dark' ? 'tw-text-gray-300' : 'tw-text-gray-600'
                ]"
              >
                {{ unidade.nome }}
              </router-link>

              <div
                v-if="unidadesFiltradas.length === 0"
                class="tw-p-4 tw-text-center tw-text-sm tw-text-gray-500"
              >
                Nenhuma unidade encontrada.
              </div>
            </div>
          </div>
        </div>

        <!-- User menu -->
        <div class="tw-relative">
          <button 
            @click="menuUser = !menuUser; menuUnidade = false"
            :class="[
              'tw-flex tw-items-center tw-space-x-1 xs:tw-space-x-3 tw-p-1 tw-rounded-full focus:tw-outline-none', 
              theme === 'dark' ? 'hover:tw-bg-gray-800' : 'hover:tw-bg-gray-100'
            ]"
          >
            <div class="tw-w-6 xs:tw-w-8 tw-h-6 xs:tw-h-8 tw-bg-[#33b35a] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-[10px] xs:tw-text-[11px] tw-font-bold tw-text-white tw-shadow-lg">
              {{ user ? user.nome.charAt(0).toUpperCase() : 'U' }}
            </div>
          </button>

          <div v-if="menuUser" 
            :class="[
              'tw-absolute tw-right-0 tw-mt-2 tw-w-40 xs:tw-w-48 tw-rounded-lg tw-shadow-xl tw-z-50 tw-overflow-hidden tw-border', 
              theme === 'dark' ? 'tw-bg-[#0f1114] tw-border-gray-800' : 'tw-bg-white tw-border-gray-200'
            ]"
          >
            <router-link to="/minha-conta" @click="menuUser = false" 
              :class="[
                'tw-flex tw-items-center tw-px-3 md:tw-px-4 tw-py-2 md:tw-py-3 tw-text-xs', 
                theme === 'dark' ? 'tw-text-gray-300 hover:tw-bg-gray-800' : 'tw-text-gray-600 hover:tw-bg-gray-50'
              ]"
            >
              <i class="fa-solid fa-user tw-mr-2 tw-text-gray-500"></i> Minha Conta
            </router-link>
            <button @click="authLogout" 
              :class="[
                'tw-w-full tw-flex tw-items-center tw-px-3 md:tw-px-4 tw-py-2 md:tw-py-3 tw-text-xs tw-text-red-500 tw-border-t tw-text-left', 
                theme === 'dark' ? 'tw-border-gray-800 hover:tw-bg-red-500/10' : 'tw-border-gray-100 hover:tw-bg-red-50'
              ]"
            >
              <i class="fa-solid fa-right-from-bracket tw-mr-2"></i> Sair
            </button>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapGetters, useStore } from 'vuex';
import { watch, ref, computed } from 'vue';

export default {
    setup () {
        const store = useStore();
        const vue_app_name = process.env.VUE_APP_NAME;
        const version = process.env.VUE_APP_VERSION;
        const menuUnidade = ref(false);
        const menuUser = ref(false);

        const unidadeAtual = ref({});
        const unidades = computed(() => store.state.unidades.unidades || []);
        const buscaUnidade = ref('');

        watch(() => store.state.unidade.unidade, (newUnidade) => {
            unidadeAtual.value = newUnidade || {};
        }, { immediate: true });

        return {
            vue_app_name,
            version,
            unidades,
            unidadeAtual,
            menuUnidade,
            menuUser,
            buscaUnidade
        }
    },
    computed: {
        ...mapGetters('auth', ['getUser']),
        ...mapGetters('ui', ['theme']),
        user() { return this.getUser; },
        unidadesFiltradas() {
          const busca = this.buscaUnidade.toLowerCase().trim();

          if (!busca) {
            return this.unidades;
          }

          return this.unidades.filter(unidade =>
            unidade.nome.toLowerCase().includes(busca)
          );
        }
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('ui', ['toggleSidebar', 'toggleTheme']),
        async authLogout() {
            try {
                await this.logout();
                this.$router.push('/v2/login');
            } catch (error) {
                console.error('Erro ao fazer logout:', error);
            }
        },
        isActive(route) {
            return this.$route.name === route || this.$route.path.includes(route);
        }
    }
}
</script>

<style scoped>.theme-fade-enter-active,
.theme-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.theme-fade-enter-from {
  transform: rotate(-90deg) scale(0);
  opacity: 0;
}

.theme-fade-leave-to {
  transform: rotate(90deg) scale(0);
  opacity: 0;
}


.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #33b35a; border-radius: 10px; }
.fa-chevron-down { transition: transform 0.2s ease; }
</style>